<template>
  <div :class="['Form-field--radio radio', className, {'Form-field--checked':isChecked}]">
    <input
      :id="id"
      :name="name"
      :value="modelValue"
      :required="required"
      :checked="isChecked"
      :disabled="disabled"
      v-bind="$attrs"
      type="radio"
      class="Form-input"
      @change="onChange"
    >
    <label
      :for="id"
      class="Form-label"
    >
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <!--For radios this may not be needed-->
    <error-messages
      :errors="error.errors"
    />
    <hint-message
      :hint="hint"
    />
  </div>
</template>

<script>
/* eslint no-underscore-dangle: 0 */
import formInputMixin from '@/mixins/form-input-mixin';

export default {
  mixins: [formInputMixin],

  model: {
    prop: 'modelData',
    event: 'rmp:change',
  },

  props: {
    id: {
      type: String,
      default() {
        return `radio-id-${Math.floor(Math.random() * 1000) * 5}`;
      },
    },
    name: {
      type: String,
      default: null,
    },
    modelValue: {
      default: null,
      type: [String, Number, Boolean],
    },
    value: {
      default: null,
      type: [String, Number, Boolean],
    },
    className: {
      type: String,
      default: null,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      required: true,
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'rmp:change'],

  computed: {
    isChecked() {
      return this.modelValue === this.value;
    },
  },

  methods: {
    onChange() {
      if (this.disabled) {
        return;
      }

      this.$emit('update:modelValue', this.value);
      this.$emit('rmp:change', this.value);
    },
  },
};
</script>
<style scoped>

</style>
